<template>
  <div class="client-user-component">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 back-row" v-show="!user.client">
          <button class="btn btn-primary" v-on:click="back()">
            <i class="fa fa-backward" aria-hidden="true"></i> Voltar
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12 title-col">
          <h5>{{formType == 'create' ? 'Novo usuário' : 'Editar usuário'}}</h5>
        </div>
        <div class="col-lg-12">
          <div class="form-group">
            <label for>
              Nome
              <span class="required-field">*</span>
            </label>
            <input v-model="user.name" class="form-control" />
          </div>
        </div>
        <div class="col-12">
          <contact-form-component :contact="user.contact"></contact-form-component>
        </div>
        <div class="col-lg-12 col-12" v-show="admin_editing">
          <div class="form-group">
            <label for>Observações</label>
            <input type="text" v-model="user.comments" class="form-control" />
          </div>
        </div>
        <div class="col-lg-4 col-12" v-if="admin_editing">
          <div class="form-group">
            <label for>
              Quantidade de logins simultâneos
              <span class="required-field">*</span>
            </label>
            <input type="number" min="0" v-model="user.simultaneous_logins" class="form-control" />
          </div>
        </div>
        <div class="col-lg-4 col-12" v-if="admin_editing">
          <div class="form-group">
            <label for>
              Situação do Usuário
              <span class="required-field">*</span>
            </label>
            <select v-model="user.status" class="form-control">
              <option
                v-for="(item, index) in createParams.status"
                :value="item"
                v-bind:key="index"
              >{{item}}</option>
            </select>
          </div>
        </div>
        <div class="col-lg-4 col-12" v-if="admin_editing">
          <div class="form-group">
            <label for style="color: transparent">Placeholder</label>
            <div class="d-flex align-items-center justify-content-end toggle-input">
              <label for>
                Pode alterar a senha
                <span class="required-field">*</span>
              </label>
              <toggle-button
                v-model="user.can_change_password"
                v-bind:key="user.can_change_password"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-12">
          <div class="form-group">
            <label for>
              Login
              <span class="required-field">*</span>
            </label>
            <input
              type="text"
              v-model="user.login"
              class="form-control"
              :disabled="formType == 'edit'"
              v-on:change="verifyUniqueLogin()"
            />
          </div>
        </div>
        <div class="col-lg-4 col-12" v-if="user.can_change_password || admin_editing">
          <div class="form-group">
            <label for>
              {{formType == 'create' ? 'Senha' : 'Nova senha'}}
              <span class="required-field">*</span>
            </label>
            <input type="password" v-model="user.password" class="form-control" />
          </div>
        </div>
        <div class="col-lg-4 col-12" v-if="user.can_change_password || admin_editing">
          <div class="form-group">
            <label for>
              Confirmar senha
              <span class="required-field">*</span>
            </label>
            <input type="password" v-model="user.confirm_password" class="form-control" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <button class="btn btn-primary float-right" v-on:click="save()">Salvar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import ContactFormComponent from "@/components/forms/ContactFormComponent";
import validator from "@/imports/validator/validate";
import contact_validate from "@/imports/validator/models/contact";
import user_validate from "@/imports/validator/models/user";
import Swal from "sweetalert2";
import { bus } from "@/main";

export default {
  name: "client-user-component",
  props: {
    client_id: Number,
    admin_editing: Boolean,
  },
  components: {
    ContactFormComponent,
  },
  data() {
    return {
      formType: "create",
      createParams: {},
      user: {
        contact: {},
        user_type_id: 2,
        simultaneous_logins: 5,
      },
    };
  },
  mounted() {
    this.getCreateParams();
  },
  methods: {
    editClient: function (user) {
      this.formType = "edit";
      this.user = user;
    },
    back: function () {
      this.user = {
        contact: {},
        user_type_id: 2,
      };
      (this.formType = "create"), this.$emit("back");
    },
    getCreateParams: function () {
      this.user.contact.mail_marketing =
        this.user.contact.mail_marketing == "true";

      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/clients/create`)
        .then((data) => {
          this.createParams = data.data;
        });
    },
    verifyUniqueLogin() {
      axios
        .post(`${process.env.VUE_APP_API_HOST}/api/unique_login`, {
          login: this.user.login,
        })
        .then((response) => {
          if (response.data.exists == 1) {
            Swal.fire({
              title: "Parece que esse login já existe",
              icon: "info",
            });
            this.user.login = "";
          }
        })
        .catch((error) => {
          Swal.fire({
            title: "Ocorreu um erro.",
            icon: "error",
          });
        });
    },
    validateChangePassword: function () {
      if (this.formType == "edit") {
        if (this.user.password) {
          if (this.user.confirm_password) {
            if (this.user.confirm_password != this.user.password) {
              return {
                field: "password",
                message: `As senhas não conferem.`,
              };
            }
          } else {
            return {
              field: "confirm_password",
              message: `O campo Confirmar senha é necessário.`,
            };
          }
        }
      }
    },
    save: function () {
      if (!this.admin_editing && this.formType == "create") {
        return false;
      }
      let errors = validator.validate(this.user, user_validate.model);
      errors = errors.concat(
        validator.validate(this.user.contact, contact_validate.model)
      );

      let password_error = this.validateChangePassword();
      if (password_error) {
        errors.push(password_error);
      }

      if (errors.length == 0) {
        bus.$emit("changeLoading", true);

        if (this.user.contact.mail_marketing == "true") {
          this.user.contact.mail_marketing = true;
        }
        if (this.user.contact.mail_marketing == "false") {
          this.user.contact.mail_marketing = false;
        }
        if (this.admin_editing == true) {
          this.user.client_id = this.client_id;
        }
        let promise =
          this.formType == "create"
            ? axios.post(`${process.env.VUE_APP_API_HOST}/api/users`, this.user)
            : axios.put(
                `${process.env.VUE_APP_API_HOST}/api/users/${this.user.id}`,
                this.user
              );

        promise.then((response) => {
          bus.$emit("changeLoading", false);
          if (response.data.id) {
            Swal.fire({
              title:
                this.formType == "create"
                  ? "Novo usuário cadastrado"
                  : "Usuário alterado com sucesso",
              icon: "success",
              onClose: () => {
                this.back();
              },
            });
          }
        });
      } else {
        let html = "Preencha todos os campos obrigatórios.";
        if (errors.length < 4) {
          html = "";
          errors.forEach((el) => (html += el.message + "<br>"));
        }
        Swal.fire({
          title: "Atenção",
          html: html,
          icon: "warning",
        });
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
.client-user-component {
  .back-row {
    margin-bottom: 15px;
  }
  .title-col {
    padding-top: 8px;
    padding-bottom: 12px;
  }
}
</style>